<template>
  <div class="person-center-main-function">
    <div
      v-for="(item, index) in getMainFunctionList"
      :key="index"
      @click="itemClick(item)"
      class="person-center-main-function-item"
    >
      <img :src="require(`@assets/${item.icon}`)" alt />
      <div>{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "toupatient"
    }
  },
  data() {
    return {
      outPatientMainFunctionList: [
        {
          title: "预约记录",
          path: "appointment-record",
          icon: "mine_appointmentrecords.png"
        },
        {
          title: "充值记录",
          path: "recharge-record",
          icon: "mine_rechargerecords.png"
        },
        {
          title: "门诊卡包",
          path: "change-card",
          icon: "mine_cardpackage.png"
        },
        {
          title: "修改手机",
          path: "relative-phone",
          icon: "mine_modifyphone.png"
        }
      ],
      inPatientMainFunctionList: [
        {
          title: "充值记录",
          path: "recharge-record",
          icon: "mine_rechargerecords.png"
        },
        {
          title: "住院卡包",
          path: "change-card",
          icon: "mine_cardpackage.png"
        }
      ]
    };
  },
  computed: {
    getMainFunctionList() {
      if (this.type === "inpatient") {
        return this.inPatientMainFunctionList;
      }
      return this.outPatientMainFunctionList;
    }
  },
  methods: {
    itemClick(item) {
      this.$emit("routeToDetail", item);
    }
  }
};
</script>

<style lang="less">
.person-center-main-function {
  display: flex;
  align-items: center;
  height: 100%;
  height: 5rem;
  margin: -3rem 5% 0.5rem 5%;
  background: white;
  border-radius: 5px;

  &-item {
    width: 25%;
    text-align: center;
    img {
      width: 1.75rem;
      height: 1.75rem;
    }
    div {
      margin-top: 0.2rem;
      color: rgba(0, 0, 0, 0.85);
      font-size: 0.75rem;
    }
  }
}
</style>
